import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { hasBooleanFeatures } from 'components/shared/featureFlag';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { agentHasRole } from '../../../../shared/agentRole/agentHasRole';
import { settingsMenuCategories } from '../menuCategories';
/** Creates a setting menu depending on the role of current agent. */
export function useSettingsMenu() {
    const { agent, allFeatureFlags } = useAppSelector((state) => ({
        allFeatureFlags: state.settings.profile.featureflags,
        agent: state.settings.profile.profile,
    }), shallowEqual);
    return useMemo(() => settingsMenuCategories.reduce((menu, category) => {
        const accessibleMenuItems = category.items.filter(({ featureFlags, featureFlagsStrategy, minimumAgentRole }) => agentHasRole(agent, minimumAgentRole) &&
            hasBooleanFeatures(allFeatureFlags, featureFlags, featureFlagsStrategy));
        if (accessibleMenuItems.length) {
            return [...menu, Object.assign(Object.assign({}, category), { items: accessibleMenuItems })];
        }
        return menu;
    }, []), [agent, allFeatureFlags]);
}
